<app-back-button></app-back-button>
<div class="header">
  <div class="instituicao-info">
    <div class="name-area">
      <div class="left-area">
        <div class="avatar">
          <p-avatar
            *ngIf="!imageError && imagePreview; else defaultAvatar"
            [image]="$any(imagePreview)"
            shape="circle"
            size="xlarge"
            (onImageError)="imageError = true"
          />
          <ng-template #defaultAvatar>
            <p-avatar
              [label]="getInitials(perfilEmpresagestora?.nome)"
              [icon]="!perfilEmpresagestora?.nome ? 'pi pi-building' : undefined"
              shape="circle"
              size="xlarge"
            />
          </ng-template>
        </div>
        <div class="title-header">
          <span class="name" style="text-transform: uppercase;">{{ perfilEmpresagestora?.nome | uppercase}}</span>
          <div class="info">
            <span>{{ perfilEmpresagestora?.natureza | enumToString }}</span>
            <span>•</span>
            <span><p-tag *ngIf="perfilEmpresagestora?.activo" severity="success" value="Activo" />
              <p-tag *ngIf="!perfilEmpresagestora?.activo" severity="danger" value="Inactivo" />
            </span>
          </div>
        </div>
      </div>
      <div class="indicator">
        <div class="book">
          <img src="icons/users-01.svg" alt="Country Icon" />
        </div>
        <div class="text-bg">
          <span>{{ formacaoCount || 0 }} Estudantes</span>
        </div>
      </div>
    </div>
    <div class="contact-info">
      <div class="phone">
        <div class="icon">
          <img src="icons/phone.svg" alt="Phone Icon" />
        </div>
        <span>{{ perfilEmpresagestora?.telefone1 }}</span>
      </div>
      <div class="email">
        <div class="icon">
          <img src="icons/email.svg" alt="Email Icon" />
        </div>
        <span>{{ perfilEmpresagestora?.email }}</span>
      </div>
      <div class="site">
        <div class="icon">
          <img src="icons/globe-01.svg" alt="map Icon" />
        </div>
        <span>{{ perfilEmpresagestora?.site }}</span>
      </div>
      <div class="country">
        <div class="icon">
          <img src="icons/map-pin.svg" alt="Country Icon" />
        </div>
        <span>{{ perfilEmpresagestora?.endereco }}</span>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <p-button class="Btn-small-auxiliar" label="Editar Empresa gestora" icon="pi pi-pen-to-square" iconPos="right"
    severity="secondary" [outlined]="true" (click)="showDialog()" *appHasAnyRole="['actualizar_empresa_gestora']" />
  <p-button class="Btn-small-auxiliar"
    [label]="perfilEmpresagestora?.activo ? 'Desativar empresa gestora' : 'Ativar empresa gestora'"
    [icon]="perfilEmpresagestora?.activo ? 'pi pi-power-off' : 'pi pi-check-circle'" iconPos="right" severity="info"
    [outlined]="true" (click)="toggleInstituicaoGestoraStatus()" />
  <!-- <p-button class="Btn-small-auxiliar" [outlined]="true" severity="danger" label="Eliminar empresa gestora"
    (click)="desativarEmpresa(perfilEmpresagestora.id)" icon="pi pi-trash" iconPos="right" /> -->
  <!--<p-button class="Btn-small-auxiliar"
    [label]="perfilEmpresagestora?.activo  ? 'Desativar empresa gestora' : 'Activar Empresa Gestora'"
    icon="pi pi-check-circle" iconPos="right" severity="info" [outlined]="true" (click)="toggleInstituicaoGestoraStatus()" />
 <p-button label="Mais sobre a empresa" icon="pi pi-info-circle" iconPos="right" [text]="true" severity="secondary" (onClick)="showMaisDetalhes(perfilEmpresagestora.item)" />-->
</div>
<p-tabs [(value)]="activeTab" (valueChange)="onTabClick(+$event)">
  <p-tablist>
    <!-- <p-tab value="0">
      <div class="tab-icon">
        <img src="icons/users-01.svg" alt="Email Icon" />
      </div>
      Auxílios de formações
    </p-tab> -->
    <p-tab [value]="0" style="text-transform: uppercase;">
      <div class="tab-icon">
        <img src="icons/book-closed.svg" alt="Email Icon" />
      </div>
      Estudantes
    </p-tab>
    <p-tab [value]="1" style="text-transform: uppercase;">
      <div class="tab-icon">
        <img src="icons/building-03.svg" alt="Email Icon" />
      </div>
      Instituições de Ensino
    </p-tab>
    <p-tab [value]="2" style="text-transform: uppercase;">
      <div class="tab-icon">
        <img src="icons/users-01.svg" alt="Email Icon" />
      </div>
      Representantes
    </p-tab>

  </p-tablist>
  <p-tabpanels>

    <p-tabpanel [value]="0">
      <app-instituicoes-ensino-listar-bolseiros
        (bolseiroCount)="setFormacaoCount($event)"></app-instituicoes-ensino-listar-bolseiros>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <app-listar-instituicao-de-ensino
        [perfilEmpresaGestora]="perfilEmpresagestora"></app-listar-instituicao-de-ensino>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <app-search-bar [showFilterBtn]="true" (onFilterBtnClick)="showFilterModal()" [sortFields]="sortFields"
        primaryBtnLabel="Novo Representante" (onPrimaryBtnClick)="irParaAddRepresentante()"
        (formValueChange)="handleFormValueChange($event)"></app-search-bar>
      <ng-container *ngIf="representantes?.length; else noDataTemplate">
        <app-representante-card *ngFor="let representante of representantes; trackBy: trackById"
          [representantes]="representante" [foto]="fotoPreviewMap[representante.id]"
          [instituicaoGestora]="perfilEmpresagestora" (edit)="editarRepresentante(representante)"
          (delete)="desativarRepresentante(representante)"
          (redefinirSenha)="redefinirSenhaRepresentante(representante)">
        </app-representante-card>

        <div class="pagination-controls">
          <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
            [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
            (pageChange)="onPageChange($event)">
          </app-paginator-control>
        </div>
      </ng-container>

      <ng-template #noDataTemplate>
        <div class="no-data">
          <app-data-void titulo="Nenhum representante encontrada"
            descricao="Clieque em Adicionar novo representante para criar um."></app-data-void>
        </div>
      </ng-template>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<p-toast></p-toast>
<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-drawer [(visible)]="visible" position="right" [style]="{'width': '720px'}"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-template #headless>
    <app-maisdetalhes-instituicoes-gestoras [instituicao]="perfilEmpresagestora" (onCloseModal)="visible=false" />
  </ng-template>
</p-drawer>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>

  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>